/* THE DEPRECIATION / AMORTIZATION METHODS -- one owner (W-063, 2026-09-29).
 *
 * Read by: the D&A page's asset editor (DAModulePage), the Step-8 review grid (AdminPage) and the asset template spec
 * (templateSpecs `asset.method`, whose values ARE `DEP_METHOD_IDS` and whose value aliases ARE `DEP_METHOD_VALUE_ALIASES`).
 * Before this file the list was written twice, with different labels (the D&A page's "Double Declining Balance", the
 * Step-8 grid's "Double-Declining").
 *
 * The engine (engines/computeDA.js assetMonthlySchedule) branches on these three ids and is deliberately NOT edited to
 * import them; the spec gate (scripts/gen-onboarding-spec.mjs, check 5) reads the engine's branches and requires they are
 * exactly DEP_METHOD_IDS. An id the engine has no branch for would book NO depreciation at all -- which is why nothing
 * may store a method that is not on this list. */

export const DEP_METHODS = [
  { id: 'SL', label: 'Straight-Line', desc: 'Equal expense each period' },
  { id: 'DDB', label: 'Double Declining Balance', desc: 'Accelerated \u2014 2\u00d7 the SL rate on book value, switches to SL' },
  { id: 'SYD', label: "Sum-of-Years' Digits", desc: 'Accelerated \u2014 front-loads using declining fraction' },
];

/* A blank method is straight-line -- the method every stored asset carries today, and the column default. */
export const DEFAULT_DEP_METHOD = 'SL';

export const DEP_METHOD_IDS = DEP_METHODS.map(m => m.id);

/* What an operator (or a converter) may write in the template's `method` cell, per method. Compared trimmed and case-
 * insensitively -- the same comparison the upload check's B3 makes, so a value the check accepts is always one the
 * parser can read. Each method's own label is included. */
const ALIASES_BY_ID = {
  SL: ['straight-line', 'straight line', 'straightline', 'straight'],
  DDB: ['double declining balance', 'double declining', 'double-declining', 'double-declining balance', 'declining balance', 'double declining-balance'],
  SYD: ["sum-of-years' digits", 'sum of years digits', "sum of years' digits", 'sum-of-years digits', 'sum of the years digits', 'sum of years', 'sum-of-years'],
};
export const DEP_METHOD_VALUE_ALIASES = DEP_METHOD_IDS.flatMap(id => ALIASES_BY_ID[id]);

/* A template cell -> a method id. Blank -> DEFAULT_DEP_METHOD. An id or an alias -> its id. Anything else -> null (the
 * caller keeps the default; the upload check has already BLOCKED the row with B3, naming it). */
export function normalizeDepMethod(value) {
  const s = String(value == null ? '' : value).trim().toLowerCase();
  if (!s) return DEFAULT_DEP_METHOD;
  for (const id of DEP_METHOD_IDS) {
    if (id.toLowerCase() === s || ALIASES_BY_ID[id].includes(s)) return id;
  }
  return null;
}
